import script from "./InfoSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoSection.vue?vue&type=script&setup=true&lang=ts"

import "./InfoSection.vue?vue&type=style&index=0&id=81d3e72c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d3e72c"]])

export default __exports__